import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";
import { ShopperBuyProductPayInputPage } from "../shopper-buy-product-pay-input/shopper-buy-product-pay-input";

@IonicPage()
@Component({
  selector: "page-shopper-buy-product-pay",
  templateUrl: "shopper-buy-product-pay.html",
})
export class ShopperBuyProductPayPage {
  data = {
    merchant_id: "",
    shop_id: "",
    shop_name: "",
    avalible: "",
    price: "",
  };
  bgImage = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {
    this.data = this.navParams.data;

    this.bgImage = "assets/bg/shop/" + this.data.shop_id + ".jpg";
    // this.bgImage = 'assets/bg/shop/1.jpg';
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  scan() {
    this.navCtrl.push(ShopperBuyProductPayInputPage, { space: this.data });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay/shopper-buy-product-pay.ts